import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { HttpError } from '../http'
import { getLockoutStatus, getMe } from './services'
import { GetMeResponse, LockoutStatus } from './types'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useQueryGetMe = (options?: Omit<UseQueryOptions<GetMeResponse, HttpError>, 'queryKey'>) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AUTH.GET_ME],
    queryFn: () => getMe(),
    ...options,
  })
}

export const useQueryGetLockoutStatus = (options?: Omit<UseQueryOptions<LockoutStatus, HttpError>, 'queryKey'>) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AUTH.LOCKOUT_STATUS],
    queryFn: getLockoutStatus,
    ...options,
  })
}
